<template>
  <section>
    <nav-component
      :titulo="'Registro de ingresos y gastos'"
      :link="{ path: '/formulario-gastos-pagos' }"
      :texto="'Registrar'"
    />
    <div class="box">
      <b-field grouped group-multiline>
        <b-field label="Busqueda Por tipo" expanded>
          <b-input
            type="text"
            v-model="filtros.tipo"
            placeholder="Tipo de gasto a buscar Ej: Nomina"
            @input="busquedaPorTipo"
          ></b-input>
        </b-field>

        <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />

        <b-field label="Nombre" expanded>
          <b-input
            type="text"
            placeholder="Nombre del proveedor/empleado/aliado"
            v-model="filtros.nombre"
            @input="busquedaPorNombre"
          ></b-input>
        </b-field>

        <b-field v-if="totalFiltros" label="Total">
          <span>${{ parseInt(totalFiltros).toLocaleString("es-CO") }}</span>
        </b-field>
      </b-field>
    </div>

    <b-table
      class="box"
      :data="gastosPagos"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      default-sort="fecha"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="tipoGasto"
        label="Tipo"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.tipoGasto }}
      </b-table-column>

      <b-table-column
        field="row"
        label="Nombre"
        sortable
        searchable
        v-slot="props"
      >
        {{ getNombreValido(props.row) }}
      </b-table-column>

      <b-table-column
        field="numeroFactura"
        label="numeroFactura"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.numeroFactura }}
      </b-table-column>

      <b-table-column
        field="fecha"
        label="fecha"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.fecha }}
      </b-table-column>

      <b-table-column
        field="total"
        label="total "
        sortable
        searchable
        v-slot="props"
      >
        ${{ parseInt(props.row.valor).toLocaleString("es-CO") }}
      </b-table-column>

      <b-table-column
  field="valores"
  label="valores"
  sortable
  searchable
  v-slot="props"
>
  <span>
    <strong>Efectivo:</strong> ${{ parseInt(props.row.efectivo).toLocaleString("es-CO") }}
    <br>
    <strong>Nequi:</strong> ${{ parseInt(props.row.nequi).toLocaleString("es-CO") }}
    <br>
    <strong>N Comercial:</strong> ${{ parseInt(props.row.nequiComercial).toLocaleString("es-CO") }}
    <br>
    <strong>Bancolombia :</strong> ${{ parseInt(props.row.tarjeta).toLocaleString("es-CO") }}
    <br>
    <strong>Otra Cuenta :</strong> {{ parseInt(props.row.transferencia).toLocaleString("es-CO") }}
  </span>
</b-table-column>


      <b-table-column
        field="observaciones"
        label="Observaciones "
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.observaciones }}
      </b-table-column>

      <b-table-column
        field="concepto"
        label="concepto"
        sortable
        searchable
        v-slot="props"
      >
        <span
          :style="{
            color:
              props.row.concepto === 'Gasto'
                ? 'red'
                : props.row.concepto === 'Ingreso'
                ? 'green'
                : 'black',
          }"
        >
          {{ props.row.concepto }}
        </span>
      </b-table-column>

      <b-table-column field="eliminar" label="Eliminar" v-slot="props">
        <b-button
          type="is-danger"
          icon-left="delete"
          @click="eliminar(props.row.id, props.row.nombre)"
        ></b-button>
      </b-table-column>

      <!-- <b-table-column field="editar" label="Editar" v-slot="props">   Editado no se usara por ahora, queda pendiente realizar el form de editar
        <b-button
          type="is-info"
          icon-left="pencil"
          @click="editar(props.row.id)"
        ></b-button>
      </b-table-column> -->
    </b-table>
  </section>
</template>
    
    <script>
import Swal from "sweetalert2";
import HttpService from "../../Servicios/HttpService";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";
import NavComponent from "../Extras/NavComponent";
import BusquedaEnFecha from "../Extras/BusquedaEnFecha.vue";
export default {
  mixins: [NotificacionesMixin],
  components: { NavComponent, BusquedaEnFecha },

  data: () => ({
    isPaginated: true,
    totalFiltros: "",
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: "bottom",
    defaultSortDirection: "desc", // Cambiado a "desc" para ordenar de manera descendente
    sortIcon: "arrow-up",
    sortIconSize: "is-medium",
    currentPage: 1,
    perPage: 50,
    gastosPagos: [],
    filtros: {
      tipo: "",
      fecha: "",
    },
    fechaInicio: "",
    fechaFin: "",
  }),

  mounted() {
    this.obtenerGastosPagos();
  },

  methods: {
    onBusquedaEnFecha(fechas) {
      this.fechaInicio = fechas[0].toISOString().split("T")[0];
      this.fechaFin = fechas[1].toISOString().split("T")[0];
      this.busquedaPorFecha();
    },
    getNombreValido(row) {
      // Verificar y devolver el primer valor no nulo ni "N/A"
      if (row.nombreEmpleado && row.nombreEmpleado !== "N/A") {
        return row.nombreEmpleado;
      }
      if (row.nombreProveedor && row.nombreProveedor !== "N/A") {
        return row.nombreProveedor;
      }
      if (row.nombreAliado && row.nombreAliado !== "N/A") {
        return row.nombreAliado;
      }
      return "Nombre no disponible"; // Opcional: texto por defecto si todos los valores son nulos o "N/A"
    },
    obtenerGastosPagos() {
      let payload = {
        accion: "obtenerGastosPagos",
      };
      HttpService.obtenerConConsultas("reportes.php", payload).then(
        (resultado) => {
          this.gastosPagos = resultado.filter((item) => item.id !== 0);
        }
      );
    },
    eliminar(id, nombre) {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto! Se eliminarán " + nombre,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminarlo",
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargando = true; // Indicamos que comienza una operación
          HttpService.eliminar("reportes.php", {
            accion: "eliminarGastosPagos",
            id: id,
          })
            .then((response) => {
              if (response === true) {
                // Verificamos que la respuesta sea true
                this.mostrarNotificacion("success", "Gasto/Pago eliminado");
                this.obtenerGastosPagos(); // Asegúrate de que esta función esté manejada correctamente
              } else {
                this.mostrarNotificacion(
                  "error",
                  "Error en la respuesta de la API"
                );
              }
            })
            .catch((error) => {
              console.error("Error al eliminar:", error); // Log más detallado del error
              this.mostrarNotificacion("error", "Error al eliminar");
            })
            .finally(() => {
              this.cargando = false; // Asegúrate de que el estado de carga se restablezca
            });
        }
      });
    },

    editar(id) {
      this.$router.push({
        name: "FormularioGastosPagosEditar",
        params: { id: id },
      });
    },
    busquedaPorTipo() {
      let payload = {
        accion: "busquedaPorTipo",
        tipo: this.filtros.tipo,
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
      };
      HttpService.obtenerConConsultas("reportes.php", payload)
        .then((transacciones) => {
          this.gastosPagos = transacciones;
          this.totalFiltros = this.calcularTotal(transacciones);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    busquedaPorNombre() {
      let payload = {
        accion: "busquedaPorNombre",
        tipo: this.filtros.nombre,
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
      };
      HttpService.obtenerConConsultas("reportes.php", payload)
        .then((transacciones) => {
          this.gastosPagos = transacciones;
          this.totalFiltros = this.calcularTotal(transacciones);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    busquedaPorFecha() {
      let payload = {
        accion: "busquedaPorFecha",
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
      };
      HttpService.obtenerConConsultas("reportes.php", payload)
        .then((transacciones) => {
          this.gastosPagos = transacciones;
          this.totalFiltros = this.calcularTotal(transacciones);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    calcularTotal(transacciones) {
      return transacciones.reduce((total, transaccion) => {
        return total + parseFloat(transaccion.valor || 0);
      }, 0);
    },
  },
  computed: {
    // Computed property para consolidar los nombres
    filas() {
      return this.items.map((item) => ({
        ...item,
        nombre: this.getNombreValido(item),
      }));
    },
  },
};
</script>
    
    